const MINE = process.env.REACT_APP_BUILD_VERSION;
let stale = false;

// True once /version.json reports a different build than the one running in this tab.
export const checkVersion = async () => {
  if (stale) return true;
  try {
    const r = await fetch(`/version.json?t=${Date.now()}`, { cache: "no-store" });
    const v = r.ok && (await r.json()).version;
    if (v && MINE && v !== MINE) stale = true;
  } catch { /* offline or not deployed yet: try again later */ }
  return stale;
};
